import {createBrowserHistory} from "history";
import * as React from "react";
import GlobalProps from "./GlobalProps";

export const history = createBrowserHistory();

export const StaffContext = React.createContext(null);

export const globals = new GlobalProps();
